









import { Vue, Component } from 'vue-property-decorator';

import CalendarAdminPage from './components/Admin.vue';
import CalendarDoctorPage from './components/Doctor.vue';

import UserModule from '@/store/user';

import { SelectItem } from '@/components/select/types';
import { BackendItem } from '@/types/models/common';
import { EventBus } from '@/lib/EventBus';

const transformBackendItem = (item: BackendItem) => ({
    id: item.id,
    value: item.title,
})

@Component({
    components: {
        CalendarAdminPage,
        CalendarDoctorPage,
    },
})
export default class ViewCalendar extends Vue {
    doctorId = 0;
    clinics: SelectItem[] = []
    specializations: SelectItem[] = []
    
    get page() {
        if (UserModule.isAdmin) {
            return CalendarAdminPage;
        }

        return CalendarDoctorPage;
    }

    created() {
        if (UserModule.isDoctor) {
            this.doctorId = UserModule.doctorId;
        }

        EventBus.$on('calendar:clinics', this.updateDoctor);
    }

    async updateDoctor(doctor: any) {
        if (UserModule.isDoctor) {
            return;
        }

        this.clinics = doctor.clinics.map(transformBackendItem);
    }
}
